module.exports = __webpack_public_path__ + "img/mes.fbeac230.png";